// Is a given value equal to null?
export default function isNull(obj) {
  return obj === null;
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isNull.js
// module id = g6u0
// module chunks = 0